import { ReactElement } from 'react';

export const LoadingCell = (): ReactElement => (
  <div className="mb-2 flex h-8 animate-pulse items-center px-2">
    <span className="inline-block h-5 w-full rounded-lg bg-gray-100 group-first:rounded-l-lg group-last:rounded-r-lg" />
  </div>
);
